import clientAxios from './../../config/axios';

export const getAllDrawers = ({ filter, pagination }: any) => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/drawers?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  return clientAxios.get(url);
};

export const updateDrawer = (drawer: any) => {
  const url = `/drawers?country=${process.env.REACT_APP_ENV_COUNTRY}&id=${drawer.id}`;
  return clientAxios.put(url, drawer);
};

export const deleteKeyService = async (key_id: any) => {
  const url = `/drawers`;
  await clientAxios.delete(url, {
    data: {
      key_id,
      country: process.env.REACT_APP_ENV_COUNTRY,
    },
  });
};

export const createDrawer = (drawer: any) => {
  const url = `/drawers`;
  return clientAxios.post(url, drawer);
};
